module.exports = __webpack_public_path__ + "static/media/thumbnail.868d7995.jpg";